import type { CharacterState, Pact } from "@/data/types";
import { CURRENT_RULES_VERSION, rulesRegistry } from "@/data/rules";
import { decodeCharacter } from "@/lib/characterUrl";

export const STEPS = [
  "Name & Background",
  "Core Skills",
  "Dark Offerings",
  "Otherworldly Gifts",
  "Spell Allocation",
  "Review & Share",
];

export const DEFAULT_STATE: CharacterState = {
  rulesVersion: CURRENT_RULES_VERSION,
  name: "",
  background: "",
  coreSkillSelections: [],
  pacts: [],
  spellAllocations: [],
  bonusSkillPoints: 0,
  bonusGifts: 0,
  bonusPacts: [],
};

export function emptyPact(): Pact {
  return { darkOfferingId: 0, patronId: "", giftId: "" };
}

export function loadInitialState(
  searchParams: URLSearchParams
): CharacterState {
  const encoded = searchParams.get("c");
  if (encoded) {
    const decoded = decodeCharacter(encoded);
    if (decoded) return decoded;
  }
  // Hidden fallback: /creator?rules=1 starts a new sheet on older rules, so a
  // player can rebuild a previous character and then run the upgrade walkthrough.
  const requested = searchParams.get("rules");
  if (requested && rulesRegistry[requested]) {
    return { ...DEFAULT_STATE, rulesVersion: requested };
  }
  return DEFAULT_STATE;
}
